import { MAIN_ENDPOINT } from "../../../config/api-client";

export const QUERY_KEY = "contracts";
export const ENDPOINT = MAIN_ENDPOINT;
